const ACTION_CONTEXTS = {
  PURCHASE: 'PURCHASE',
  ANY: 'ANY'
};
export { ACTION_CONTEXTS };